import React, {useEffect} from 'react'
import {BrandFooter, Card, CardActionButton, CardHeader, SignInLayout} from '../components/SigninLayout'
import {DatePicker, Errors, TextInput, WithForm} from '@startlibs/form'
import {ExpiredPage} from './errors/ExpiredPage'
import {urlTokenFormFetch} from '../utils/authFetch'
import _ from 'lodash/fp'
import {formatDate} from '@startlibs/utils'
import {responseFailure} from '../utils/validation'
import {buildShareSession} from '../utils'
import {HelpButton} from "../components/HelpButton";
import {SPA_ORIGIN} from './ShareDialog'
import {DATE_FORMAT} from '../utils/DateFormat'
import {LoadingPage} from '../components/PageLoading'

export const ACCESS_ERROR = "Invalid patient data. Please check the fields above and try again."

const transformDoB = (dobSubmitFormat) => _.update('dob',(dob) => {
  return formatDate(_.isNumber(dob) ? new Date(dob) : dob,dobSubmitFormat).replace(/\//g,'')
})


export const ShareLogin = ({withoutFooter, dobSubmitFormat = 'MM/dd/yyyy', labels = {}, providerInfo,navigate, shareInfo, authenticationResponse,token,successUrl = (token) => '/shared/'+token, onSessionReady}) => {

  const expired = shareInfo.jwtExpired

  const needHelp = providerInfo.needHelp


  const onSuccess = (_,{jwt,...rest}) => {
    onSessionReady(buildShareSession(jwt, rest, shareInfo))
    navigate(successUrl(token))
  }

  const onFailure = responseFailure((data,{status})=> status === 401 && {"lastName":ACCESS_ERROR,"dob":ACCESS_ERROR})

  useEffect(() => {
    if (authenticationResponse) {
      onSuccess('',{...shareInfo,...authenticationResponse})
    }
  },[authenticationResponse])

  if (authenticationResponse) {
    return <LoadingPage/>
  }

  if (expired) {
    return <ExpiredPage providerInfo={providerInfo}/>
  }

  return <SignInLayout withoutFooter={withoutFooter} providerInfo={providerInfo} className="notranslate">
      <Card>
        <CardHeader>
          <h1>{labels.title || "Confirm patient data to access records"}</h1>
          <p>{labels.subtitle || "Please confirm the patient identity to access the shared records"}</p>
        </CardHeader>
        <WithForm
          alwaysSave
          onSuccess={onSuccess}
          transform={transformDoB(dobSubmitFormat)}
          onFailure={onFailure}
          action={urlTokenFormFetch(SPA_ORIGIN() + '/api/share/authenticate')}
        >{form => <>
          {
            shareInfo.phiProtectionAttributes.lastName &&
          <TextInput
            label="Patient last name"
            placeholder="Ex: Smith"
            path="lastName"
          />
          }
          {
            shareInfo.phiProtectionAttributes.dob &&
          <DatePicker
            weekStartsMonday
            label="Patient date of birth"
            placeholder={`Ex: ${DATE_FORMAT(providerInfo.dateFormat).toUpperCase()}`}
            format={DATE_FORMAT(providerInfo.dateFormat)}
            path="dob"
          />
          }
          <Errors/>
          <CardActionButton highlight isLoading={form.isLoading} type="submit">{labels.button || "Access Shared Records"}</CardActionButton>
        </>}</WithForm>
        {!withoutFooter && <BrandFooter/>}
      </Card>
      <HelpButton needHelp={needHelp} />
    </SignInLayout>
}